import Axios from "../../../axios";
import {metaConstants} from "../../../constants/ApiConstant";

export async function searchMeta() {
    return Axios.get(metaConstants.META_SEARCH);
}
